<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="employeeListGroupsAndWorkTypes"
        :page-data="pageData"
        :loading="loadingAnimation"
        change-style
        sort-az="id"
      >
        <div class="mb-6 d-flex flex-column gap-5" slot="buttons">
          <div class="d-flex flex-wrap align-center gap-5">
            <EmployeesCreateModal
              v-if="$userCheckAccess({ abilities: ['edit_hr', 'add_employees'] })"
            />
            <EmployeeRolesLinkModal
              v-if="$userCheckAccess({ abilities: ['edit_hr', 'view_work_roles'] })"
              :create="true"
            />
            <BaseInput
              type="autocomplete"
              v-model="filter.status.value"
              :items="filter.status.list"
              :label="localStorage.translations.pages.personnel_department['employees-group_tables']['status-sotrudnika']"
              v-bind="bindInput"
              :multiple="false"
              @change="onDownloadPageData()"
              :key="'status' + filter.status.value"
            />
          </div>
        </div>
        <div class="employeeGrid" v-if="$route.query.style_list === 'grid'">
          <EmployeesListItem
            v-for="(employee, index) in employeeListGroupsAndWorkTypes"
            :key="index"
            :employee="employee"
            :onDownloadPageData="onDownloadPageData"
          />
        </div>
        <EmployeesTable :employees="employeeListGroupsAndWorkTypes" v-else />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import EmployeesCreateModal from 'components/employees/EmployeesCreateModal'
// import EmployeesInviteModal from 'components/employees/EmployeesInviteModal'
import EmployeeRolesLinkModal from 'components/employees/EmployeeRolesLinkModal'
import EmployeesListItem from 'components/employees/EmployeesListItem'
import EmployeesTable from 'components/employees/EmployeesTable'

export default {
  name: 'Employees',
  components: {
    TemplateView,
    TemplatePageGrid,
    EmployeesTable,
    EmployeesListItem,
    EmployeesCreateModal,
    // EmployeesInviteModal,
    EmployeeRolesLinkModal,
  },
  data: () => ({
    bindInput: {
      multiple: true,
      minimize: true,
      'small-chips': true,
      clearable: true,
      placeholder: '—',
    },
    menu: false,
    key: 0,
    filter: {
      project: {
        list: [],
        value: [],
      },
      team: {
        list: [],
        value: [],
      },
      status: {
        list: [],
        value: null,
      },
    },
  }),
  created() {
    if (this.$route.query.worker_status !== 'undefined') {
      this.filter.status.value = this.$route.query.worker_status
    }
    this.onDownloadPageData()
    // this.$route.query.style_list = 'table'
  },
  computed: {
    ...mapGetters('employee', ['pageData', 'employeeListGroupsAndWorkTypes']),
    ...mapGetters(['loadingAnimation']),
    translation() {
      return this.localStorage.translations.pages.projects['reports_table']
    },
  },
  watch: {
    '$route.query'(newData, oldData) {
      if (newData.style_list === oldData.style_list) {
        this.onDownloadPageData()
      }
    },
  },
  methods: {
    ...mapActions('employee', ['onEmployeeListGroupsAndWorkTypes']),
    async onDownloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        filter_1: {},
      }
      if (this.filter.status.value && this.filter.status.value.length){
        data.filter_1.status = this.filter.status.value
      }
      // if (this.filterParams.length) {
      //     data.filters = this.filterParams
      // }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      
      await this.onEmployeeListGroupsAndWorkTypes(data).then(() => {
        this.filter.status.list = [
          {id: 'started', name: this.localStorage.translations.pages.common.text.start},
          {id: 'stopped', name: this.localStorage.translations.pages.common.text.stop},
          {id: 'with_reports', name: this.localStorage.translations.pages.common.text['add_report']},
          {id: 'not_started', name: this.localStorage.translations.pages.common.text['not_started']},
          {id: 'free_workers', name: this.localStorage.translations.pages.common.text['free_workers']},
        ]
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-row-gap: 30px;
  .btnGroup {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-column-gap: 30px;
    &.right {
      grid-template-columns: auto;
    }
  }
  .employeeGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 24px;
  }
}
</style>